<div>
  <div class="row col-12 gestion-container">
    <h3 class="title-section"> Perfiles </h3>
    <!-- MAIN CARD -->
    <div class="card mt-4 col-12">
      <div class="card-body">
        <div class="row col-12">
          <!-- COLUMNA 1 -->
          <div class="col-sm-12 col-md-8 mt-2">
            <p>Para poder asignar puestos a un nuevo perfil, créalo y posteriormente modifica los puestos 
              de los perfiles creados. Recuerda que todos los puestos deben tener asignado un perfil.</p>
            <!-- BUSCADOR -->
            <div class="mb-3">
              <mat-icon class="icon-c-folder icon-search"> search </mat-icon>
              <div class="col-12 row mt-2">
                <div class="col-sm-12 col-md-6 search-input">
                  <input 
                    matInput 
                    (keyup)="filterByName($event)" 
                    class="form-control form-create" 
                    placeholder="Buscar" 
                    style="padding-left: 42px;"
                    #input
                  >
                </div>
              </div>
            </div>
            <!-- CARD -->
            <div class="card mt-2 col-12 mb-4">
              <!-- TABS MENU -->
              <div class="mt-2">
                <mat-tab-group (selectedTabChange)="onChangeFilter($event.index)" class="tabs-container" animationDuration="0ms">
                  <mat-tab label="Orden numerico"> </mat-tab>
                  <mat-tab label="Orden alfabetico"></mat-tab>
                </mat-tab-group>
              </div>
              <div class="card-body perfiles-margin" style="overflow: auto; height: 460px;">
                <div class="row col-md-12 mt-4">
                  <!-- LISTADO PERFILES -->
                  <div class="col-sm-12 col-md-4 col-md-8-5 mt-3">
                    <div class="btn-group" role="group" aria-label="Button group">
                      <div class="btn-group" role="group">
                        <button type="button" class="btn btn-new-profile radius-btn" (click)="changeView('propiedades-perfil', 0)">
                          <strong> Nuevo perfil </strong>
                        </button>
                      </div>
                      <button type="button" class="btn btn-new-profile radius-btn" (click)="changeView('propiedades-perfil', 0)">
                        <mat-icon class="icon-c-folder icon-display" svgIcon="icon-plus"></mat-icon>
                      </button>
                    </div>
                  </div>
                  <!-- NG-FOR -->
                  <div class="col-sm-12 col-md-4 col-md-8-5 mt-3" *ngFor="let item of dataSource">
                    <div class="btn-group text-center mb-3" role="group" aria-label="Button group">
                      <div class="btn-group" role="group">
                        <button 
                          id="btnGroup" 
                          type="button" 
                          class="btn btn-perfil radius-btn" 
                          (click)="changeView('propiedades-perfil', item)"
                          >
                            {{ item.nombrePerfil }}
                        </button>
                      </div>
                      <button type="button" class="btn btn-perfil radius-btn" (click)="openModal(deleteProfile); onDeleteItem(item)">
                        <mat-icon class="icon-c-folder icon-display " svgIcon="icon-delete"></mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  COLUMNA 2 -->
          <div class="mt-4 col-sm-12 col-md-4">
            <app-modulos-asignados
              [stepId]="step"
            >
            </app-modulos-asignados>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL ELMINAR PERFIL -->
  <ng-template #deleteProfile let-modal>
    <div class="card-alert">
      <!-- Imagen -->
      <div class="col-md-6 offset-md-3 mt-4 text-center confirmation">
        <img class="warning-image" src="https://s3.amazonaws.com/dev.structure.files/assets/advertencia.png" />
        <h3 class="mt-2">Advertencia</h3>
      </div>
      <div class="col-md-8 offset-md-2">
        <p class="text-center alert-body mt-3">
          ¿Estás seguro que quieres eliminar el perfil?
        </p>
      </div>
      <!-- FOOTER -->
      <div class="pt-2 col-12 mt-3 mb-4 footer-modal">
        <button type="button" class="btn btn-cancel radius-btn" (click)="modal.close('Close click');">
          <strong style="padding-right: 5px;">Cancelar</strong>
        </button>
        <button type="button" class="btn btn-acept-modal radius-btn" (click)="deleteItem(); modal.close('Close click');">
          <strong style="padding-right: 5px;">Aceptar</strong>
        </button>
      </div>
    </div>
  </ng-template>

</div>